export const space = {
  margin: {
    scale: 'space',
  },
  marginTop: {
    scale: 'space',
  },
  marginRight: {
    scale: 'space',
  },
  marginBottom: {
    scale: 'space',
  },
  marginLeft: {
    scale: 'space',
  },
  marginBlockEnd: {
    scale: 'space',
  },
  marginBlockStart: {
    scale: 'space',
  },
  marginBlock: {
    scale: 'space',
  },
  marginStart: {
    scale: 'space',
    properties: ['marginInlineStart'],
  },
  marginEnd: {
    scale: 'space',
    properties: ['marginInlineEnd'],
  },
  marginInlineEnd: {
    scale: 'space',
  },
  marginInlineStart: {
    scale: 'space',
  },
  marginInline: {
    scale: 'space',
  },
  marginX: {
    scale: 'space',
    properties: ['marginInlineStart', 'marginInlineEnd'],
  },
  marginY: {
    scale: 'space',
    properties: ['marginBlockStart', 'marginBlockEnd'],
  },
  padding: {
    scale: 'space',
  },
  paddingTop: {
    scale: 'space',
  },
  paddingRight: {
    scale: 'space',
  },
  paddingBottom: {
    scale: 'space',
  },
  paddingLeft: {
    scale: 'space',
  },
  paddingStart: {
    scale: 'space',
    properties: ['paddingInlineStart'],
  },
  paddingEnd: {
    scale: 'space',
    properties: ['paddingInlineEnd'],
  },
  paddingBlockEnd: {
    scale: 'space',
  },
  paddingBlockStart: {
    scale: 'space',
  },
  paddingBlock: {
    scale: 'space',
  },
  paddingInlineEnd: {
    scale: 'space',
  },
  paddingInlineStart: {
    scale: 'space',
  },
  paddingInline: {
    scale: 'space',
  },
  paddingX: {
    scale: 'space',
    properties: ['paddingInlineStart', 'paddingInlineEnd'],
  },
  paddingY: {
    scale: 'space',
    properties: ['paddingBlockStart', 'paddingBlockEnd'],
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Space = typeof space;
